import React from 'react'
import PropTypes from 'prop-types'
import {Flex, Text, useStyleConfig, ListItem, UnorderedList} from '@chakra-ui/react'
import {CheckIcon} from '../../../icons/others'

const AccordionList = ({lists}) => {
    const styles = useStyleConfig('Accordion')

    if (!Array.isArray(lists) || lists.length === 0) return

    return (
        <UnorderedList {...styles.accordionList}>
            {lists.map((list, index) => (
                <ListItem key={index} sx={styles.listItem}>
                    <Flex {...styles.accordionPanelElement}>
                        {list?.value_name && (
                            <Text {...styles.accordionPanelTextList}>{list.value_name}</Text>
                        )}
                        {list?.has_check ? (
                            <CheckIcon
                                data-testid="check-icon"
                                color="button.background.primary-default"
                                {...styles.checkIconBox}
                            />
                        ) : (
                            <>
                                {list?.value && (
                                    <Text {...styles.accordionPanelTextList}>{list.value}</Text>
                                )}
                            </>
                        )}
                    </Flex>
                </ListItem>
            ))}
        </UnorderedList>
    )
}

AccordionList.propTypes = {
    lists: PropTypes.arrayOf(
        PropTypes.shape({
            value_name: PropTypes.string,
            has_check: PropTypes.bool,
            value: PropTypes.string,
        }),
    ),
}

export default AccordionList
